<template>
  <div class="toolbox">
    <!-- 工具箱标志，添加文字提示 -->
    <el-button
      @click="toggleToolbox"
      class="toolbox-toggle"
      type="success"
      circle
      title="点击展开/收起工具箱"
    >
      {{ isOpen ? "×" : "☰" }}
    </el-button>
    <!-- 展开的工具箱 -->
    <transition name="fade">
      <div v-if="isOpen" class="toolbox-content">
        <!-- 第一个按钮显示图例，添加图标 -->
        <el-button class="toolbox-button" type="text" title="显示图例" @click="showShipLegend">
          <i class="el-icon-map-location"></i> 图例
        </el-button>
        <!-- 可添加更多按钮 -->
        <el-button
          class="toolbox-button"
          type="text"
          title="测量地图上的距离"
          @click="toggleMeasureDistance"
        >
          <i class="el-icon-setting"></i> 测距离
        </el-button>
        <el-button
          class="toolbox-button"
          type="text"
          title="测量地图上的面积"
          @click="toggleMeasureArea"
        >
          <i class="el-icon-star-on"></i> 测面积
        </el-button>
        <el-button class="toolbox-button" type="text" title="AI助手" @click="toggleAiChat">
          <i class="el-icon-chat-line-round"></i> AI助手
        </el-button>
      </div>
    </transition>
    <!-- 根据 showLegend 状态显示 ship-legend 组件 -->
    <ship-legend v-if="showLegend" @close="hideShipLegend" />
  </div>
</template>

<script>
// 引入 ship-legend 组件
import ShipLegend from "../components/common/ShipLegend.vue";

export default {
  components: {
    ShipLegend,
  },
  props: {
    // AI对话框显示状态
    aiChatVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["toggle-ai-chat"],
  data() {
    return {
      // 控制工具箱是否展开
      isOpen: false,
      // 控制 ship-legend 组件是否显示
      showLegend: false,
    };
  },
  methods: {
    // 切换工具箱展开状态
    toggleToolbox() {
      this.isOpen = !this.isOpen;
    },
    // 点击图例按钮时显示 ship-legend 组件
    showShipLegend() {
      this.showLegend = true;
    },
    hideShipLegend() {
      this.showLegend = false;
    },
    // 切换测距功能
    toggleMeasureDistance() {
      // 如果当前测面积功能已开启，先关闭它
      if (this.$store.state.measureArea) {
        this.$store.commit("SET_MEASURE_AREA", false);
      }
      // 然后切换测距功能状态
      this.$store.commit("SET_MEASURE_DISTANCE", !this.$store.state.measureDistance);
    },
    toggleMeasureArea() {
      // 如果当前测距功能已开启，先关闭它
      if (this.$store.state.measureDistance) {
        this.$store.commit("SET_MEASURE_DISTANCE", false);
      }
      // 然后切换测面积功能状态
      this.$store.commit("SET_MEASURE_AREA", !this.$store.state.measureArea);
    },
    // 切换AI对话框
    toggleAiChat() {
      // 触发事件通知父组件切换AI对话框显示状态
      this.$emit("toggle-ai-chat");
    },
  },
};
</script>

<style scoped>
.toolbox {
  position: fixed;
  bottom: 121px;
  right: 20px;
  z-index: 1000;
}

.toolbox-toggle {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: rgba(13, 236, 76, 0.9);
  color: white;
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  border-radius: 4px;
  width: 32px;
  height: 32px;
}

.toolbox-content {
  position: absolute;
  /* 让框体底部和按钮垂直居中对齐 */
  bottom: 60%;
  transform: translateY(43%);
  /* 让框体显示在按钮左侧并保持间距 */
  right: 34px;
  width: 72px;
  max-height: 400px;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.toolbox-button {
  flex-direction: column; /* 强制垂直排列 */
  align-items: center; /* 水平居中 */
}

.toolbox-button i {
  display: block; /* 图标独占一行 */
  margin: 0 0 6px 0; /* 仅设置下边距 */
}

/* 删除下方所有重复的.toolbox-button样式 */
</style>

<style scoped>
.toolbox-content {
  /* 合并后的容器样式 */
  width: 72px;
  padding: 8px 0;
  border: 1px solid rgba(76, 175, 80, 0.15);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.1);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.7);
}

.toolbox-button {
  /* 统一按钮样式 */
  min-width: 64px;
  height: 56px;
  margin: 4px 0;
  padding: 6px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.toolbox-button.el-button--text {
  color: #ffffff; /* 修改按钮文字颜色为白色，适配黑色背景 */
}

.toolbox-button.el-button--text:hover {
  color: #ffffff; /* 悬停时也保持白色 */
}

.toolbox-button i {
  /* 图标样式 */
  color: #e4eced;
  font-size: 18px;
  margin-bottom: 6px;
}

.toolbox-button:hover {
  /* 悬停效果 */
  background: rgba(76, 175, 80, 0.05);
  transform: scale(1.02);
  box-shadow: 0 2px 6px rgba(76, 175, 80, 0.1);
}

/* 删除下方所有重复的样式定义 */
</style>

<style scoped>
.toolbox-toggle {
  background-color: rgba(0, 173, 239, 0.9);
  color: white;
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  border-radius: 4px;
  width: 32px;
  height: 32px;
}

.toolbox-content {
  border: 1px solid rgba(0, 150, 136, 0.15);
  box-shadow: 0 4px 12px rgba(0, 150, 136, 0.1);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.7);
}

.toolbox-button.el-button--text {
  color: #ffffff; /* 统一按钮文字颜色为白色 */
}

.toolbox-button.el-button--text:hover {
  color: #ffffff; /* 悬停时也保持白色 */
}

/* 第一个按钮（图例按钮）图标样式 */
.toolbox-button:nth-child(1) i {
  color: #00ffff;
}

/* 第二个按钮（测距离）图标样式 */
.toolbox-button:nth-child(2) i {
  color: #03a9f4;
}

/* 第三个按钮图标样式 */
.toolbox-button:nth-child(3) i {
  color: #ffb6c1;
}

/* 第四个按钮（AI助手）图标样式 */
.toolbox-button:nth-child(4) i {
  color: #9c27b0;
}

::v-deep .el-button + .el-button,
::v-deep .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0px;
}
</style>
